/* @flow weak */
import { compact } from 'lodash';
import Button from 'components/Button.jsx';
import CarouselPropTypes from 'components/lib/CarouselPropTypes';
import cx from 'classnames';
import Glyph from 'components/Glyph.jsx';
import ProgressSteps from 'components/ProgressSteps.jsx';
import React from 'react';

import './styles/Carousel.scss';

class Carousel extends React.Component {
  static propTypes = {
    initialIndex: React.PropTypes.number,
    showPageControls: React.PropTypes.bool,
    progressLabels: React.PropTypes.array,
    showBackControlsIndices: CarouselPropTypes.showBackControlsIndices,
    clickablePageControls: React.PropTypes.bool,
    children(props, propName) {
      if (React.Children.count(props[propName]) < 2) {
        return new Error('Carousel expects at least two child elements');
      }
    },
  };

  static defaultProps = {
    showPageControls: true,
    showBackControlsIndices: null,
    clickablePageControls: true,
  };

  state = {
    index: this.props.initialIndex || 0,
  };

  getChildren = () => {
    return compact(this.props.children);
  };

  displayPage = (index) => {
    this.setState({ index });
  };

  next = () => {
    this.displayPage(this.state.index + 1);
  };

  previous = () => {
    this.displayPage(this.state.index - 1);
  };

  isFirstPage = () => {
    return this.state.index === 0;
  };

  renderPageControls = () => {
    const onClick = this.props.clickablePageControls ? this.displayPage : null;
    return (
      <ProgressSteps
        labels={this.props.progressLabels}
        steps={(
          (this.props.progressLabels &&
          this.props.progressLabels.length) ||
          this.getChildren().length
        )}
        current={this.state.index + 1}
        onClick={onClick}
      />
    );
  };

  renderBackControllers = () => {
    let button;
    if (this.isFirstPage() ||
        this.props.showBackControlsIndices === null) {
      return button;
    }

    if (this.state.index >= this.props.showBackControlsIndices[0] &&
        this.state.index <= this.props.showBackControlsIndices[1]) {
      button = (
        <Button color="thunder" level="icon" onClick={this.previous}>
          <Glyph name="arrow-left" size="large" solo />
        </Button>
      );
    }
    return button;
  };

  render() {
    return (
      <div className="Carousel">
        <div className="Carousel-controls Carousel-control-back">
          {this.props.showBackControlsIndices && this.renderBackControllers()}
        </div>
        <div className="Carousel-controls Carousel-controls-pages">
          {this.props.showPageControls && this.renderPageControls()}
        </div>
        <div
          className={cx('Carousel-page', {
            'Carousel-page-withControls': this.props.showPageControls,
          })}>
          {this.getChildren()[this.state.index]}
        </div>
      </div>
    );
  }
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/components/Carousel.jsx